<div #topElement class="divWhiteBackground" id="capq-verification-required">
  <div class="d-flex flex-column align-items-center">
    <h2 class="dark-blue text-center" id="cac-verification-required-heading">
      Additional Verification Required
    </h2>

    <div
      class="gray-banner gray-banner-spaced gray-banner-large-text text-center"
    >
      We are unable to complete your online prequalification request at this
      time. No credit decision has been made.
    </div>

    <p class="text-center">
      Additional verification is required. Please visit any dealership in our
      network to discuss financing options. The dealer can assist with your
      request.
    </p>

    <div class="gray-banner gray-banner-large-text text-center">
      Please bring a valid government-issued photo ID.
    </div>

    <p class="text-center">
      Once the verification process is completed, your request may be evaluated
      for financing.
    </p>

    <div class="pt-61 form-group center">
      <a
        class="btn btn-primary btn-default width-100"
        id="cac-verification-required-find-dealers"
        [href]="dealerFinderUrl"
      >
        Find Local Dealers
      </a>
    </div>

    <p class="verification-disclaimer text-center">
      Visiting a participating dealer does not guarantee financing or credit
      approval.
    </p>
  </div>
</div>
